module.exports = __webpack_public_path__ + "img/img_left_nav_bonus.603931ba.svg";